import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  width: "50",
  height: "28.3",
  viewBox: "0 0 50 28.3",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M24.999 0 0 24.996 3.303 28.3 25.005 6.596l21.7 21.611L50 24.898Z"
  })]
});